import { render } from "./DeleteExpiredRoom.vue?vue&type=template&id=3b030374&scoped=true&ts=true"
import script from "./DeleteExpiredRoom.vue?vue&type=script&lang=ts"
export * from "./DeleteExpiredRoom.vue?vue&type=script&lang=ts"

import "./DeleteExpiredRoom.vue?vue&type=style&index=0&id=3b030374&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b030374"]])

export default __exports__